import React, { useState } from "react";
import { Multiselect } from "@hopper/multiselect";

type OptionsList = Array<{
  value: string;
  label: string;
  isSelected: boolean;
}>;

type ControlledMultiselectProps = {
  items: OptionsList;
  onChange: (items: OptionsList) => void;
  disabled?: boolean;
};

const ControlledMultiselect = ({ items, onChange, disabled = false }: ControlledMultiselectProps) => {
  const [isOpen, updateIsOpen] = useState(false);

  const closePopup = () => updateIsOpen(false);

  const onPrimaryButtonClicked = (items: OptionsList) => {
    closePopup();
    onChange(items);
  };

  const clearOptions = () => {
    closePopup();
    onChange(items.map(item => ({ ...item, isSelected: false })));
  };

  const toggleIsOpen = () => {
    if (disabled) {
      return;
    }

    updateIsOpen(!isOpen);
  };

  const selectedItems = items.filter(item => item.isSelected);
  const label = selectedItems.length > 0 ? selectedItems.map(({ label }) => label).join(", ") : "Select";

  return (
    <Multiselect
      optionsList={items}
      onInputClick={toggleIsOpen}
      isOpen={isOpen}
      value={label}
      primaryButtonText="Apply"
      secondaryButtonText="Clear"
      onPrimaryButtonClicked={onPrimaryButtonClicked}
      onSecondaryButtonClicked={clearOptions}
      onOutsideClick={closePopup}
      disabled={disabled}
    />
  );
};

export default ControlledMultiselect;
